module.exports = __webpack_public_path__ + "img/img28.236d0f02.png";